<div #chartOptions class="dropdown" [ngClass]="{show: isOpen}">
    <a class="btn btn-secondary btn-block dropdown-toggle user-select-none"
       (click)="toggle()">
        <span>
            <span> {{ chartOptionsConfig().title.label }}</span>
        </span>
    </a>
    <div class="dropdown-menu" [ngClass]="{show: isOpen}">
        @for (listItem of chartOptionsConfig().list; track listItem.value) {
            @if (listItem.dividerAbove) {
                <div class="dropdown-divider"></div>
            }
            @if (listItem.value === FundChartOptionValue.CONVERT_CURRENCY && currencyDropdownConfig(); as currencyConfig) {
                <div class="dropdown dropdown-nested"
                     (mouseenter)="isCurrencyMenuOpen = true"
                     (mouseleave)="isCurrencyMenuOpen = false">
                    <label class="custom-control custom-checkbox dropdown-item dropdown-toggle">
                        <input class="custom-control-input"
                               type="checkbox"
                               (change)="updateChartOptions(listItem)"
                               [(ngModel)]="listItem.selected">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description" [textContent]="listItem.label"></span>
                        @if (listItem.helpName) {
                            <span>&nbsp;</span>
                            <span class="help-toggler" (click)="helpModal.openModal(listItem.helpName); false">(?)</span>
                        }
                    </label>
                    <div class="dropdown-menu dropdown-menu-scrollable-lg" [ngClass]="{show: isCurrencyMenuOpen}">
                        @for (currencyItem of currencyConfig.list; track $index) {
                            @if (currencyItem.type === 'divider') {
                                <div class="dropdown-divider"></div>
                            } @else {
                                <label class="custom-control custom-checkbox dropdown-item custom-checkbox-style1">
                                    <input class="custom-control-input"
                                           type="radio"
                                           name="fund-chart-currency"
                                           [checked]="currencyItem.selected"
                                           (click)="updateChartCurrency(currencyItem)">
                                    <span class="custom-control-indicator"></span>
                                    <span class="custom-control-description" [textContent]="currencyItem.label"></span>
                                </label>
                            }
                        }
                    </div>
                </div>
            } @else {
                <div>
                    <label class="custom-control custom-checkbox dropdown-item"
                           [ngClass]="{'custom-checkbox-tall': listItem.description}">
                        <input class="custom-control-input"
                               type="checkbox"
                               (change)="updateChartOptions(listItem)"
                               [(ngModel)]="listItem.selected">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description" [textContent]="listItem.label"></span>
                        @if (listItem.helpName) {
                            <span>&nbsp;</span>
                            <span class="help-toggler" (click)="helpModal.openModal(listItem.helpName); false">(?)</span>
                        }
                    </label>
                </div>
            }
            @if (listItem.dividerUnder) {
                <div class="dropdown-divider"></div>
            }
        }
        <div class="dropdown-divider"></div>
        @if (dataInFooterDropdownConfig(); as dataInFooterConfig) {
            @if (dataInFooterConfig.list.length) {
                <ycn-multi-select-dropdown
                    [dropdownContainerClass]="'dropdown-nested'"
                    [buttonClass]="'dropdown-item'"
                    [dropdownItemClass]="'pl-40'"
                    [config]="dataInFooterConfig"
                    (changeHandler)="updateChartOptions($event)">
                </ycn-multi-select-dropdown>
            }
        }
        @if (dataInLegendDropdownConfig(); as dataInLegendConfig) {
            <ycn-single-select-dropdown
                [customCssClasses]="{
                    dropdownContainer: 'dropdown-nested',
                    button: 'dropdown-item',
                    dropdownItem: 'pl-40'}"
                [customLabel]="'Data in Legend'"
                [config]="dataInLegendConfig"
                (changeHandler)="updateChartDataInLegend($event)">
            </ycn-single-select-dropdown>
        }
        <ycn-single-select-dropdown
                [customCssClasses]="{
                    dropdownContainer: 'dropdown-nested',
                    button: 'dropdown-item',
                    dropdownItem: 'pl-40'}"
                [customLabel]="'Name in Legend'"
                [config]="nameInLegendOptionsConfig()"
                (changeHandler)="updateChartNameInLegend($event)">
        </ycn-single-select-dropdown>
        @if (valueFlagsDropdownConfig(); as valueFlagsConfig) {
            <ycn-single-select-dropdown
                [customCssClasses]="{
                    dropdownContainer: 'dropdown-nested',
                    button: 'dropdown-item',
                    dropdownItem: 'pl-40'}"
                [customLabel]="'Value Flags'"
                [config]="valueFlagsConfig"
                (changeHandler)="updateChartValueFlags($event)">
            </ycn-single-select-dropdown>
        }
        @if (frequencyOptionsConfig(); as frequencyConfig) {
            <div class="dropdown-divider"></div>
            <ycn-single-select-dropdown
                [customCssClasses]="{
                    dropdownContainer: 'dropdown-nested',
                    button: 'dropdown-item',
                    dropdownItem: 'pl-40'}"
                [customLabel]="'Period'"
                [config]="frequencyConfig"
                (changeHandler)="updateChartFrequency($event)">
            </ycn-single-select-dropdown>
        }

    </div>
</div>
<ycn-help-modal #helpModal></ycn-help-modal>
